import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import endOfWeek from 'date-fns/endOfWeek';
import isSameDay from 'date-fns/isSameDay';
import isWithinInterval from 'date-fns/isWithinInterval';
import startOfWeek from 'date-fns/startOfWeek';
import {DatePicker} from "@mui/lab";
import {useEffect, useState} from "react";

const CustomPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) =>
    prop !== 'dayIsBetween' && prop !== 'isFirstDay' && prop !== 'isLastDay',
})(({ theme, dayIsBetween, isFirstDay, isLastDay }) => ({
  ...(dayIsBetween && {
    borderRadius: 0,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '&:hover, &:focus': {
      backgroundColor: theme.palette.primary.dark,
    },
  }),
  ...(isFirstDay && {
    borderTopLeftRadius: '50%',
    borderBottomLeftRadius: '50%',
  }),
  ...(isLastDay && {
    borderTopRightRadius: '50%',
    borderBottomRightRadius: '50%',
  }),
}));

/**
 * @param {Number} startWeekDay between 0 and 6
 * @param {Function} onChange Passes up the start date value
 * @param {Boolean} disabled Disables changing the date.
 * @param {Boolean} center If true, centers the date in the box.
 * @returns {React.Component}
 */
export default function WeekSelector({startWeekDay, onChange, disabled = false, center = false}) {
  const [value, setValue] = useState(new Date());

  useEffect(() => {
    const start = startOfWeek(new Date(), {weekStartsOn: startWeekDay});
    setValue(start);
    onChange(start);
  }, [startWeekDay, onChange]);

  const renderWeekPickerDay = (date, selectedDates, pickersDayProps) => {
    if (!value) {
      return <PickersDay {...pickersDayProps} />;
    }

    const start = startOfWeek(value, {weekStartsOn: startWeekDay});
    const end = endOfWeek(value, {weekStartsOn: startWeekDay});
    const dayIsBetween = isWithinInterval(date, { start, end });
    const isFirstDay = isSameDay(date, start);
    const isLastDay = isSameDay(date, end);
    return (
      <CustomPickersDay
        {...pickersDayProps}
        disableMargin
        dayIsBetween={dayIsBetween}
        isFirstDay={isFirstDay}
        isLastDay={isLastDay}
      />
    );
  };

  const handleChange = (value) => {
    const start = startOfWeek(value, {weekStartsOn: startWeekDay});
    setValue(start);
    onChange(start)
  };

  return (
    // <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label="Week select"
        value={value}
        disabled={disabled}
        onChange={(newValue) => {
          // setValue(newValue);
          handleChange(newValue);
        }}
        renderDay={renderWeekPickerDay}
        renderInput={(params) => <TextField sx={{input: {textAlign:(center ? "center": "left")}}} {...params} />}
      />
    // </LocalizationProvider>
  );
}
